import React from "react";
import logo from "../../../Assets/img/AnaxisRecruit_Black (1).png";

const FormHeader = () => {
  return (
    <header className="header py-1">
      <div
        className="container d-flex justify-content-between align-items-center"
        style={{ padding: "0.5rem", gap: "0.5rem" }}
      >
        {/* Mobile: Logo left + Contact icons right */}
        <div className="d-flex d-lg-none w-100 justify-content-between align-items-center">
          <a className="navbar-brand" href="/">
            <img src={logo} height="60" alt="Logo" />
          </a>
        </div>

        {/* Desktop logo */}
        <a
          className="navbar-brand d-none d-lg-flex flex-column align-items-start"
          href="/"
        >
          <img src={logo} height="80" alt="Logo" />
        </a>

        {/* Nav (right) */}
        <nav className="mobile-nav d-flex align-items-end gap-2 ">
          <a className="nav-link d-inline-block" href="/for-candidate-form">
            For Candidates
          </a>
          <a className="nav-link d-inline-block" href="/for-employer-form">
            For Employers
          </a>
        </nav>
      </div>
    </header>
  );
};

export default FormHeader;
